import { render, staticRenderFns } from "./roleConfiguration.vue?vue&type=template&id=3ffc3b6c&scoped=true"
import script from "./roleConfiguration.vue?vue&type=script&lang=js"
export * from "./roleConfiguration.vue?vue&type=script&lang=js"
import style0 from "./roleConfiguration.vue?vue&type=style&index=0&id=3ffc3b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffc3b6c",
  null
  
)

export default component.exports